import http from 'axios';

/* eslint-disable */

type Success = any;
type Error = any;

enum Method { Get, Post }

http.defaults.baseURL = '/api-crm-web';
http.defaults.headers.post['Content-Type'] = 'application/json';
http.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest';

export function get(url: string) {
  return request(url, Method.Get);
}

export function post(url: string) {
  return request(url, Method.Post);
}

export function getCookie(name: string) { 
  const reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
  const arr = document.cookie.match(reg);
  if (arr) {
    return unescape(arr[2]);
  } else { 
    return null;
  } 
} 
export function setCookie(c_name: string, value: string, expiredays: number) {
  const exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie = c_name + '=' + escape(value) + ((expiredays === null) ? '' : ';expires=' + exdate.toUTCString());
}

export function eraseCookie(name: string) {   
  document.cookie = name + '=; Max-Age=-99999999;';  
}

function request(url: string, method: Method) {
  return (params?: any) => {
    return new Request(url, method, params);
  };
}

class Request {

  private successBlock?: (r?: Success) => void;
  private failureBlock?: (code: string, msg?: string) => void;
  private errorBlock?: (r: Error) => void;
  private doneBlock?: () => void;
  promise: Promise<any>;

  constructor(url: string, method: Method, params?: any) {
    const deferreds: any[] = [];
    this.promise = new Promise(function(resolve, reject){
      deferreds.push({resolve: resolve, reject: reject});
    });
    const req = method === Method.Get ? http.get : http.post;
    const options = {
      method: method === Method.Get ? 'GET' : 'POST',
      data: params ? params : {},
      url,
    };
    http(options).then((rs) => {
      if (rs.data.success) {
        if (this.successBlock != null) {
          this.successBlock(rs.data.result);
        }
        deferreds[0].resolve(rs.data.result);
      } else {
        if (rs.data.code === '-10000') {
          if (!getCookie('DRIP_SESSION_KEY_USER_IDENTITY')) {
            window.localStorage.removeItem('account');
            eraseCookie('DRIP_SESSION_KEY_USER_IDENTITY');
            eraseCookie('DRIP_SESSION_KEY_WX_MEMBER');
            window.location.href = '#/user/login';
          }
        } else {
          if (this.failureBlock != null) {
            this.failureBlock(rs.data.code, rs.data.msg);
          }
        }
        deferreds[0].reject(rs.data);
      }
      if (this.doneBlock != null) {
        this.doneBlock();
      }
    }).catch((err) => {
      if (this.errorBlock != null) {
        this.errorBlock(err);
      }
      if (this.doneBlock != null) {
        this.doneBlock();
      }
    });
  }

  public success(block: (r?: Success) => void): Request {
    this.successBlock = block;
    return this;
  }

  public failure(block: (code: string, msg?: string) => void): Request {
    this.failureBlock = block;
    return this;
  }

  public error(block: (r?: Error) => void): Request {
    this.errorBlock = block;
    return this;
  }

  public done(block: () => void): Request {
    this.doneBlock = block;
    return this;
  }
}
